/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { Project } from 'app/types/project';

/**
 * Get projects.
 */

function getProjects(client: AxiosInstance): Promise<Project[]> {
  return client.get(resolveAppUrl('projects')).then(({ data }) => data?.data);
}

/**
 * Export `useProjectsCacheInvalidator`.
 */

export function useProjectsCacheInvalidator() {
  const queryClient = useQueryClient();

  return useCallback(() => {
    queryClient.invalidateQueries(['projects']);
  }, [queryClient]);
}

/**
 * Export `useProjects`.
 */

export function useProjects() {
  const client = useRequestProvider();

  return useQuery(['projects'], {
    queryFn: async () => {
      return await getProjects(client);
    }
  });
}
